<app-tnt-header *ngIf="this.oauthService.hasValidIdToken()"></app-tnt-header>
<ngx-snackbar></ngx-snackbar>
<main>
    <!-- Show page content -->
    <router-outlet></router-outlet>
</main>
